import DropDownList from '../../Dropdown/DropDownList';
import GroupSVG from '../../icons/group';
import UserSVG from '../../icons/user';
import UserInfoSVG from '../../icons/userInfo';
import DocSVG from '../../icons/doc';
import GroupsTabSVG from '../../icons/groupstab';
import HomeSVG from '../../icons/home';
import GraduationCapSVG from '../../icons/GraduactionCap';
import CertificateTrackingSVG from '../../icons/certificateTrackingSVG';
import MaterialErrorSVG from '../../icons/materialErrorSVG';
import MaterialCorrectionTrackingSVG from '../../icons/materialCorrectionTracking';


const PrincipalMenu = ({ onMenuItemClick }) => {  // Recibe la función como prop

    const MenuData = [
        {
            name: "Inicio",
            icon: HomeSVG,
            link: "#",
            status: "active",
        },
        {
            name: "Alumnos",
            icon: UserSVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Info alumno",
                    icon: UserInfoSVG,
                    link: "#",
                    status: "disabled",
                },
            ],
        },
        {
            name: "Grupos",
            icon: GroupSVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Tabla de grupos",
                    icon: GroupsTabSVG,
                    link: "#",
                    status: "disabled",
                },
                {
                    name: "Listado de grupos",
                    icon: GroupSVG,
                    link: "#",
                    status: "active",
                }, {
                    name: "Agregar grupo",
                    icon: DocSVG,
                    link: "#",
                    status: "active",
                },

            ],
        },
        {
            name: "Otros",
            icon: DocSVG,
            link: "#",
            status: "active",
            children: [
                {
                    name: "Agregar fecha a calendario",
                    icon: DocSVG,
                    link: "#",
                    status: "disabled",
                },
            ],
        },
        {
            name: "Solicitar certificados",
            icon: GraduationCapSVG,
            link: "https://sistema-desarrollo-proyectos.web.app/solicitar-certificados",
            status: "active",
        },
        {
            name: "Reportar error de material",
            icon: MaterialErrorSVG,
            link: "https://sistema-desarrollo-proyectos.web.app/reportar-error-material",
            status: "active",
        },
        {
            name: "Seguimiento de certificados",
            icon: CertificateTrackingSVG,
            link: "#",
            status: "active",
        },
        {
            name: "Seguimiento de corrección de material",
            icon: MaterialCorrectionTrackingSVG,
            link: "#",
            status: "active",
        },
    ];

    return (
        <DropDownList
            Data={MenuData}
            iconColor='red'
            onMenuItemClick={onMenuItemClick} // Pasa la función a DropDownList
        />
    );
};

export default PrincipalMenu;
